"use client";
import {
  buttonVariants
} from "./chunk-24TR2GH3.js";

// src/alert-dialog.tsx
import { cn } from "@momo/utils";
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
import { jsx, jsxs } from "react/jsx-runtime";
var AlertDialog = AlertDialogPrimitive.Root;
var AlertDialogTrigger = AlertDialogPrimitive.Trigger;
var AlertDialogPortal = AlertDialogPrimitive.Portal;
var AlertDialogOverlay = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    AlertDialogPrimitive.Overlay,
    {
      className: cn(
        "fixed inset-0 z-50 bg-black/40 backdrop-blur-sm",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
        className
      ),
      ...rest
    }
  );
};
var AlertDialogContent = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsxs(AlertDialogPortal, { children: [
    /* @__PURE__ */ jsx(AlertDialogOverlay, {}),
    /* @__PURE__ */ jsx(
      AlertDialogPrimitive.Content,
      {
        className: cn(
          "bg-background fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border p-6 shadow-lg",
          "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]",
          className
        ),
        ...rest
      }
    )
  ] });
};
var AlertDialogHeader = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: cn("flex flex-col gap-2 text-center sm:text-left", className), ...rest });
};
var AlertDialogFooter = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:gap-2", className),
      ...rest
    }
  );
};
var AlertDialogTitle = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(AlertDialogPrimitive.Title, { className: cn("text-lg font-semibold", className), ...rest });
};
var AlertDialogDescription = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    AlertDialogPrimitive.Description,
    {
      className: cn("text-muted-foreground text-sm", className),
      ...rest
    }
  );
};
var AlertDialogAction = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(AlertDialogPrimitive.Action, { className: cn(buttonVariants(), className), ...rest });
};
var AlertDialogCancel = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    AlertDialogPrimitive.Cancel,
    {
      className: cn(buttonVariants({ variant: "outline" }), "mt-2 sm:mt-0", className),
      ...rest
    }
  );
};

export {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogPortal,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel
};
